import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ScanBarcode({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ScanBarcode</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5625 8.25C6.87316 8.25 7.125 8.50184 7.125 8.8125L7.125 15.1875C7.125 15.4982 6.87316 15.75 6.5625 15.75C6.25184 15.75 6 15.4982 6 15.1875L6 8.8125C6 8.50184 6.25184 8.25 6.5625 8.25Z"
        fill={color ?? 'currentColor'}
      />
      <rect x="8.625" y="8.25" width="3" height="7.5" rx="0.75" fill={color ?? 'currentColor'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6875 8.25C13.9982 8.25 14.25 8.50184 14.25 8.8125L14.25 15.1875C14.25 15.4982 13.9982 15.75 13.6875 15.75C13.3768 15.75 13.125 15.4982 13.125 15.1875L13.125 8.8125C13.125 8.50184 13.3768 8.25 13.6875 8.25Z"
        fill={color ?? 'currentColor'}
      />
      <rect x="15.75" y="8.25" width="2.25" height="7.5" rx="0.75" fill={color ?? 'currentColor'} />
      <rect x="3" y="5" width="1.5" height="4" rx="0.75" fill={color ?? 'currentColor'} />
      <rect
        x="7"
        y="5"
        width="1.5"
        height="4"
        rx="0.75"
        transform="rotate(90 7 5)"
        fill={color ?? 'currentColor'}
      />
      <rect
        x="3"
        y="19"
        width="1.5"
        height="4"
        rx="0.75"
        transform="rotate(-90 3 19)"
        fill={color ?? 'currentColor'}
      />
      <rect x="3" y="15" width="1.5" height="4" rx="0.75" fill={color ?? 'currentColor'} />
      <rect
        x="21"
        y="19"
        width="1.5"
        height="4"
        rx="0.75"
        transform="rotate(180 21 19)"
        fill={color ?? 'currentColor'}
      />
      <rect
        x="17"
        y="19"
        width="1.5"
        height="4"
        rx="0.75"
        transform="rotate(-90 17 19)"
        fill={color ?? 'currentColor'}
      />
      <rect
        x="21"
        y="5"
        width="1.5"
        height="4"
        rx="0.75"
        transform="rotate(90 21 5)"
        fill={color ?? 'currentColor'}
      />
      <rect
        x="21"
        y="9"
        width="1.5"
        height="4"
        rx="0.75"
        transform="rotate(-180 21 9)"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
